import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from '@/plugins/axios';

import fade from './directive/fade';
import slide from './directive/slide';
import circleMotion from './directive/circleMotion';
import { dateFormat } from './compositions/format';

import { numberonly, price, contact } from '@/directive/format';
import store from './store';
// 캘린더
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
// PrimeVue
import PrimeVue from 'primevue/config';
import Paginator from 'primevue/paginator';
// PrimeVue css
import 'primevue/resources/themes/lara-light-green/theme.css';
import 'primevue/resources/primevue.min.css';

// if (process.env.NODE_ENV === 'development') {
// 	const VConsole = require('vconsole'); // require 사용
// 	new VConsole();
// }
const app = createApp(App);

app.directive('fade', fade);
app.directive('slide', slide);
app.directive('circleMotion', circleMotion);
app.directive('numberonly', numberonly);
app.directive('price', price);
app.directive('contact', contact);
app.config.globalProperties.axios = axios;
app.config.globalProperties.$dateFormat = dateFormat;
app.use(store);
app.use(VCalendar, {});
app.use(router).mount('#app');
// PrimeVue
app.use(PrimeVue);
app.component('Paginator', Paginator);
